<template>
<div id="container" class="pferdegeschichten">
    <div class="fullscreen_background hintergrund">
		<img class="img" src="/static/assets/pferdegeschichten/Hintergrund.png" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <!-- <div class="moeve z30 hovering">
        <img class="img" src="/static/assets/pferdegeschichten/Moeve.png" />
    </div> -->

    <div class="hugi z33">
        <img class="img" src="/static/assets/pferdegeschichten/Hugi.png" />
    </div>
	<div class="gigi z31">
        <img class="img" src="/static/assets/pferdegeschichten/Gigi.png" />
    </div>
    <div class="dubix z31">
        <img class="img" src="/static/assets/pferdegeschichten/Dubix.png" />
    </div>
	    <div class="libero z35">
        <img class="img" src="/static/assets/pferdegeschichten/Libero.png" />
    </div>
		<div class="anton z31">
        <img class="img" src="/static/assets/pferdegeschichten/Anton.png" />
    </div>
		<div class="fuchs z31">
        <img class="img" src="/static/assets/pferdegeschichten/Fuchs.png" />
    </div>
		    <div class="jolly z31">
        <img class="img" src="/static/assets/pferdegeschichten/Jolly.png" />
    </div>
    <div class="bel bel_animation z31">
    </div>
	<div class="fledermaus fledermaus_animation z31">
    </div>
	<div class="fledermaus2 z31 fledermaus2_animation">
    </div>
	<div class="regen z30 regen_animation">
    </div>
    <router-link to="/ninjageschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil.png" />
    </router-link>

    <router-link to="/stromgeschichten" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/pferdegeschichten/Geschichte.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Dubix_Cavallo_LANGSAM.mp3" jsonurl="/static/assets/geschichten/dubix_ausgabe4.json" content=".pferdegeschichten" target="pferdegeschichten_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="pferdegeschichten_target">
        <p>„Trabt schon mal langsam los, wir kommen gleich nach!“, rief Dubix Cavallo seiner Freundin Gigi Lotta zu. Gigi Lotta nickte, gab ihrem Pferd Anton die Sporen und steuerte es zum Ausgang des Pferdehofs Fohlenwiese. Heute durfte sie endlich das erste Mal mit ihm ausreiten. Ihre Freunde Dubix Cavallo und Hugi Huf wollten sie auf ihren Pferden Jolly und Bel begleiten. Hugi Huf und sein Hund Libero Hopp aber hatten sich verspätet und so ritt Gigi Lotta, die es einfach nicht erwarten konnte, mit Anton auszureiten, schon alleine los. „Mein lieber, lieber Anton!“, flüsterte sie ihrem brav dahertrabenden Pferd ins Ohr, „jetzt zeigen wir mal, was wir können!“ Das ließ sich Anton nicht zweimal sagen. Ungestüm jagte das junge Pferd drauflos und trug seine Besitzerin geschwind über Wiesen und Felder bis tief in den Wald. Gigi Lottas Haare flatterten im Reitwind und vor lauter Pferdeglück vergaß sie ihre Freunde und ihre Abmachung, langsam loszutraben. Plötzlich stoppte Anton, vor ihm auf dem Waldweg saß in aller Seelenruhe ein Rotfuchs. Das junge Pferd erschrak, scheute und bäumte sich auf. Gigi Lotta fiel zu Boden. Auaa! Mühsam erhob sie sich. Der Rotfuchs war verschwunden, aber ihr rechter Arm schmerzte furchtbar. Sie versuchte wieder auf Anton aufzusitzen, aber die Verletzung ließ es nicht zu. „Gut, dann gehen wir eben zurück!“, sprach sie und dachte mit einiger Bange an den weiten Weg, den sie nun zu Fuß nehmen musste. Ob sie das noch schaffen würden, bevor das Gewitter loslegte, das sich da oben zusammenbraute? Ihre Überlegung war vergebens. Denn Anton rührte sich nicht. Er wich keinen Meter von der Stelle. Was tun?  </p>
<p>Gigi Lotta stiegen die Tränen hoch. Egal, jetzt musste sie erstmal was trinken. Vorsichtig, um Anton nicht weiter zu verunsichern, griff sie in ihre Satteltasche, um ihre Trinkflasche rauszuholen. Dabei fiel etwas zu Boden. Es war das Pferdebuch, das ihr Dubix Cavallo geliehen hatte. „Das schickt der Himmel! Vielleicht kann es mir verraten, wie ich meinem verschreckten Pferd jetzt helfen kann.“ Rummms — es donnerte. Da war das Gewitter! Schnell steckte sie das Buch wieder in die Satteltasche. Sie musste sich und Anton in Sicherheit bringen. Doch Anton ließ sich nicht bewegen! Plötzlich erhellte ein greller Blitz den Waldweg. Gigi Lottas Herz raste vor Angst und sie flehte ihr Pferd an: „Anton, bitte, lass uns von hier weggehen, unsere Höhle ist ganz in der Nähe.“ Doch Anton ließ sich nicht überzeugen. Gigi Lotta umarmte den Hals ihres Pferdes und ließ ihren Tränen nun laut schluchzend freien Lauf. Erbarmungslos prasselte der Regen auf beide nieder. </p>
<p>Plötzlich war durch das Rauschen des Regens hindurch ein helles Bellen zu hören. Libero Hopp hatte sie gefunden! Und hinter ihm galoppierten eilig Jolly und Bel mit Dubix Cavallo und Hugi Huf auf dem Rücken. Dubix Cavallo sprang vom Pferd und lief zu Anton und Gigi Lotta. „Was ist passiert? Wa…“ Doch seine Worte gingen im lauten Donnerschlag unter. Dubix Cavallo hielt sanft sein Gesicht an Antons Kopf und streichelte ihn. Gigi Lotta berichtete ihm kurz, was passiert ist. „Geht mit Jolly und Bel voran.“, rief er, „sie gehören zu seiner Koppelherde. Er wird ihnen folgen.“ </p>
<p>Es goss in Strömen, doch Anton trabte treu seinen Pferdefreunden nach, die von Gigi Lotta und Hugi Huf geführt wurden. Gemeinsam retteten sie sich in die Steinhöhle, wo sie sich oft trafen und alles für ein Lagerfeuer vorfanden. Sie versorgten so gut wie möglich ihre Pferde und saßen bald um das Feuer herum. Dubix Cavallo las ihnen aus seinem schlauen Pferdebuch vor, von dem er gelernt hatte, wie man mit einem verschreckten Pferd umgeht. Darüber vergaß Gigi Lotta ihre Armschmerzen und den ersten verpatzten Ausflug mit ihrem Pferd. Als sie am Abend zum Pferdehof Fohlenwiese zurückritten, flüsterte sie Anton ins Ohr: „Ich werde noch ganz viel über dich lernen müssen, mein Liebling. Aber eines weiß ich jetzt schon:</p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'pferdegeschichten',
  data () {
    return {
      who: 'pferdegeschichten'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)  
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Dubix_Cavallo_Titel.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Cavallo_Atmo2.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false) 
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }  
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* pferdegeschichten */
.pferdegeschichten { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.pferdegeschichten .himmel { display: block !important; }

.pferdegeschichten .geschichte { position: absolute; top: 153px; left:51%;  }

.pferdegeschichten .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.pferdegeschichten .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

/* pferdegeschichten .schwimmer {position: absolute; left: 28%; top: 39%; } */
.pferdegeschichten .schwimmer {position: absolute; left: 25%; top: 12%; }
.pferdegeschichten .schwimmer img{animation: schwimmer_erscheint 10s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; margin-left: -870px;}
@keyframes schwimmer_erscheint {
    0% {margin-left: -870px; opacity:0;}
    25% { opacity:1;}
    100% {margin-left: 0px; opacity:1;}
}
.pferdegeschichten .fuchs {
    position: absolute;
    top: 640px;
    left: 240px;
}
.pferdegeschichten .baer {position: absolute; /* left: 36%; top: 74%; */ left: 773px; top: 4px;}
.pferdegeschichten .baer {animation: baer_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-bottom: -270px; */}
@keyframes baer_erscheint {
    /* 50% {margin-bottom: -270px; transform: scale(0.5); opacity:0;}
    100% {margin-bottom: 0px; transform: scale(1); opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}


.pferdegeschichten .gras {position: absolute; /* left:0; bottom: -5px;*/ left: -25%; bottom: -25%;}
.pferdegeschichten .lord_knatterdorn {position: absolute; left: 270PX; bottom: 490PX;}
.pferdegeschichten .lord_knatterdorn {animation: lord_knatterdorn_erscheint 0.5s ease-out; animation-delay: 1.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-left: -270px; */}
@keyframes lord_knatterdorn_erscheint {
    /* 50% {margin-left: -270px;opacity:0;}
    100% {margin-left: 0px; opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.pferdegeschichten .koechin {position: absolute; left: 37%; bottom: 26%;}
.pferdegeschichten .hugi {position: absolute; right: 1478px;
        bottom: 195px;}
.pferdegeschichten .hugi {animation: hugi_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .pferdegeschichten .dubix {position: absolute; left: 635px;
    bottom: 65px;}
.pferdegeschichten .dubix {animation: hugi_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.pferdegeschichten .Kolibri {position: absolute; right: 955px; bottom: 643px;}
.pferdegeschichten .Kolibri {animation: schwimmen 0.5s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .pferdegeschichten .gigi {position: absolute; left: 66px;
    bottom: 50px;}
.pferdegeschichten .gigi {animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
	.pferdegeschichten .libero {
    position: absolute;
    top: 35px;
    left: 1171px;
    z-index: 510;
    }
.anton {
    position: absolute;
    top: 650px;
    left: 807px;
}
.jolly {
    position: absolute;
    top: 524px;
    left: 890px;
}
.pferdegeschichten .wasserfall {position: absolute; /* left: 23%; bottom: 6%; */}
.pferdegeschichten .moeve { position: absolute; top: 250px; left: 600px; }
.pferdegeschichten .schild { position: absolute; bottom: 29px; left: 209px; }
.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.pferdegeschichten .hovering1 {
  -webkit-animation: hovering 18s linear infinite;
  -moz-animation: hovering 18s linear infinite;
  -ms-animation: hovering 18s linear infinite;
  -o-animation: hovering 18s linear infinite;
  animation: hovering 18s linear infinite;
}
.pferdegeschichten .hovering2 {
  -webkit-animation: hovering 22s linear infinite;
  -moz-animation: hovering 22s linear infinite;
  -ms-animation: hovering 22s linear infinite;
  -o-animation: hovering 22s linear infinite;
  animation: hovering 22s linear infinite;
}
.pferdegeschichten .hovering3 {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}
.pferdegeschichten .hovering4 {
  -webkit-animation: hovering 24s linear infinite;
  -moz-animation: hovering 24s linear infinite;
  -ms-animation: hovering 24s linear infinite;
  -o-animation: hovering 24s linear infinite;
  animation: hovering 24s linear infinite;
}
/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,0px);
    -moz-transform: translate(20px,0px);
    -webkit-transform: translate(20px,0px);
    -o-transform: translate(20px,0px);
    transform: translate(20px,0px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.pferdegeschichten .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/
 
.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}
 
.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}
 
.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}
 
.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}
 
.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}
 
.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
/*************** SIMPLE INNER SCROLLBAR ***************/
 
.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}
 
.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */
 
.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69; 
    box-shadow: inset 0 0 0px #ac8a69; 
    -webkit-border-radius: 0;
    border-radius: 0;
}
 
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69; 
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69; 
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat; 
}
.bel {
    position: absolute;
    top: 580px;
    left: 500px;
}
.bel_animation {
  width: 156px;
  height: 181px;
  background: url('/static/assets/pferdegeschichten/bel_animation.png') top center;
  animation-delay: 1s;
  animation: bel_animation 4s steps(11) infinite;
  transform: scale(1);
  margin-top: 0px;
}
@keyframes bel_animation {
    100% { background-position: 0 -1991px; }
}
.regen {
    position: absolute;
    top: 239px;
    left: 57px;
}
.regen_animation {
  width: 985px;
  height: 741px;
  background: url('/static/assets/pferdegeschichten/regen_animation.png') top center;
  animation-delay: 1s;
  animation: regen_animation 1s steps(4) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes regen_animation {
    100% { background-position: 0 -2964px; }
}

.fledermaus {
    position: absolute;
    top: -10px !important;
    left: 32% !important;
}
.fledermaus_animation {
  width: 189px;
  height: 139px;
  background: url('/static/assets/pferdegeschichten/fledermaus_animation.png') top center;
  animation-delay: 1s;
  animation: fledermaus_animation 5s steps(14) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes fledermaus_animation {
    100% { background-position: 0 -1946px; }
}
	.fledermaus2 {position: absolute;top: 140px;left: 780px;}
.fledermaus2_animation {
  width: 93px;
  height: 65px;
  background: url('/static/assets/pferdegeschichten/fledermaus2_animation.png') top center;
  animation-delay: 1s;
  animation: fledermaus2_animation 6s steps(16) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes fledermaus2_animation {
	100% { background-position: 0 -1040px; }
}
	

span { font-family: FrozenMemory; }
.geschichte .player {
    top: 644px!important;
    left: 100px;
}
.spacegeschichten .player {position: absolute !important;left: 95px !important;}
</style>



// WEBPACK FOOTER //
// src/components/Pferdegeschichten.vue